import { render } from "./Standard.vue?vue&type=template&id=de6ea5ae"
import script from "./Standard.vue?vue&type=script&lang=js"
export * from "./Standard.vue?vue&type=script&lang=js"

import "./Standard.vue?vue&type=style&index=0&id=de6ea5ae&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__